const initStep3 = () => {};

export default initStep3;
